/**
 * Accessibility Widget — Israeli Standard 5568 / WCAG 2.0 AA
 * Self-contained IIFE. No dependencies.
 */
(function () {
  'use strict';

  /* ── Translations ── */
  var TRANSLATIONS = {
    en: {
      title: 'Accessibility',
      close: 'Close',
      langSwitch: 'עב',
      fontUp: 'Increase Font',
      fontReset: 'Reset Font',
      highContrast: 'High Contrast',
      grayscale: 'Grayscale',
      linkHighlight: 'Highlight Links',
      bigCursor: 'Big Cursor',
      readingGuide: 'Reading Guide',
      letterSpacing: 'Letter Spacing',
      lineHeight: 'Line Height',
      textAlign: 'Text Align Left',
      hideImages: 'Hide Images',
      resetAll: 'Reset All',
      fabLabel: 'Open accessibility menu',
      panelLabel: 'Accessibility settings',
      activated: 'activated',
      deactivated: 'deactivated',
      fontLevel: 'Font size level',
      fontResetDone: 'Font size reset',
      allReset: 'All accessibility settings reset'
    },
    he: {
      title: '\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea',
      close: '\u05e1\u05d2\u05d5\u05e8',
      langSwitch: 'EN',
      fontUp: '\u05d4\u05d2\u05d3\u05dc \u05d2\u05d5\u05e4\u05df',
      fontReset: '\u05d0\u05e4\u05e1 \u05d2\u05d5\u05e4\u05df',
      highContrast: '\u05e0\u05d9\u05d2\u05d5\u05d3\u05d9\u05d5\u05ea \u05d2\u05d1\u05d5\u05d4\u05d4',
      grayscale: '\u05d2\u05d5\u05d5\u05e0\u05d9 \u05d0\u05e4\u05d5\u05e8',
      linkHighlight: '\u05d4\u05d3\u05d2\u05e9 \u05e7\u05d9\u05e9\u05d5\u05e8\u05d9\u05dd',
      bigCursor: '\u05e1\u05de\u05df \u05d2\u05d3\u05d5\u05dc',
      readingGuide: '\u05e7\u05d5 \u05e7\u05e8\u05d9\u05d0\u05d4',
      letterSpacing: '\u05e8\u05d9\u05d5\u05d5\u05d7 \u05d0\u05d5\u05ea\u05d9\u05d5\u05ea',
      lineHeight: '\u05e8\u05d9\u05d5\u05d5\u05d7 \u05e9\u05d5\u05e8\u05d5\u05ea',
      textAlign: '\u05d9\u05d9\u05e9\u05d5\u05e8 \u05dc\u05e9\u05de\u05d0\u05dc',
      hideImages: '\u05d4\u05e1\u05ea\u05e8 \u05ea\u05de\u05d5\u05e0\u05d5\u05ea',
      resetAll: '\u05d0\u05e4\u05e1 \u05d4\u05db\u05dc',
      fabLabel: '\u05e4\u05ea\u05d7 \u05ea\u05e4\u05e8\u05d9\u05d8 \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea',
      panelLabel: '\u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea',
      activated: '\u05d4\u05d5\u05e4\u05e2\u05dc',
      deactivated: '\u05d1\u05d5\u05d8\u05dc',
      fontLevel: '\u05d2\u05d5\u05d3\u05dc \u05d2\u05d5\u05e4\u05df \u05e8\u05de\u05d4',
      fontResetDone: '\u05d2\u05d5\u05d3\u05dc \u05d2\u05d5\u05e4\u05df \u05d0\u05d5\u05e4\u05e1',
      allReset: '\u05db\u05dc \u05d4\u05d2\u05d3\u05e8\u05d5\u05ea \u05d4\u05e0\u05d2\u05d9\u05e9\u05d5\u05ea \u05d0\u05d5\u05e4\u05e1\u05d5'
    }
  };

  /* ── Feature definitions ── */
  var TOGGLE_FEATURES = [
    { id: 'highContrast', icon: '\u25d0', cssClass: 'a11y-high-contrast' },
    { id: 'grayscale', icon: '\u25d1', cssClass: 'a11y-grayscale' },
    { id: 'linkHighlight', icon: '\ud83d\udd17', cssClass: 'a11y-link-highlight' },
    { id: 'bigCursor', icon: '\ud83d\udc46', cssClass: 'a11y-big-cursor' },
    { id: 'readingGuide', icon: '\u2550', cssClass: null },
    { id: 'letterSpacing', icon: 'A\u2194B', cssClass: 'a11y-letter-spacing' },
    { id: 'lineHeight', icon: '\u2195', cssClass: 'a11y-line-height' },
    { id: 'textAlign', icon: '\u2261', cssClass: 'a11y-text-left' },
    { id: 'hideImages', icon: '\ud83d\uddbc', cssClass: 'a11y-hide-images' }
  ];

  var STORAGE_KEY = 'a11y-settings';
  var LANG_KEY = 'a11y-lang';

  /* ── State ── */
  var state = {
    open: false,
    lang: 'en',
    fontLevel: 0,
    features: {}
  };

  var elements = {};

  /* ── Helpers ── */
  function t(key) {
    var strings = TRANSLATIONS[state.lang] || TRANSLATIONS.en;
    return strings[key] || key;
  }

  function detectLang() {
    var saved = localStorage.getItem(LANG_KEY);
    if (saved && TRANSLATIONS[saved]) return saved;
    var htmlLang = (document.documentElement.lang || 'en').split('-')[0].toLowerCase();
    return TRANSLATIONS[htmlLang] ? htmlLang : 'en';
  }

  function saveSettings() {
    var data = { fontLevel: state.fontLevel, features: state.features };
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(data)); } catch (e) { /* quota */ }
  }

  function loadSettings() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);
      if (raw) {
        var data = JSON.parse(raw);
        if (typeof data.fontLevel === 'number') state.fontLevel = data.fontLevel;
        if (data.features && typeof data.features === 'object') state.features = data.features;
      }
    } catch (e) { /* corrupt */ }
  }

  function announce(message) {
    if (elements.liveRegion) {
      elements.liveRegion.textContent = '';
      setTimeout(function () { elements.liveRegion.textContent = message; }, 50);
    }
  }

  /* ── DOM Creation ── */
  function createWidget() {
    // Live region for announcements
    var liveRegion = document.createElement('div');
    liveRegion.className = 'a11y-live-region';
    liveRegion.setAttribute('aria-live', 'polite');
    liveRegion.setAttribute('aria-atomic', 'true');
    liveRegion.setAttribute('role', 'status');
    document.body.appendChild(liveRegion);
    elements.liveRegion = liveRegion;

    // Reading guide
    var readingGuide = document.createElement('div');
    readingGuide.className = 'a11y-reading-guide';
    readingGuide.setAttribute('aria-hidden', 'true');
    document.body.appendChild(readingGuide);
    elements.readingGuide = readingGuide;

    // FAB button
    var fab = document.createElement('button');
    fab.className = 'a11y-fab';
    fab.setAttribute('aria-label', t('fabLabel'));
    fab.setAttribute('aria-expanded', 'false');
    var fabImg = document.createElement('img');
    fabImg.id = 'imgAcc';
    fabImg.alt = '\u05e8\u05db\u05d9\u05d1 \u05e0\u05d2\u05d9\u05e9\u05d5\u05ea';
    fabImg.src = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='31' height='30' viewBox='0 0 31 30'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Crect fill='%23000' width='60' height='30' rx='15'/%3E%3Crect stroke='%23FFF' stroke-width='2' fill='%23000' x='3' y='3' width='54' height='24' rx='12'/%3E%3Cg transform='translate(9 7)' fill='%23FFF' fill-rule='nonzero'%3E%3Cpath d='M12.364 12.121h-1.416l-.804-2.412a1.09 1.09 0 00-1.053-.497H5.818V6.794h3.637c.401 0 .727-.325.727-.727s-.326-.728-.727-.728H5.818V4.239A2.56 2.56 0 007.273 2.18a2.182 2.182 0 10-4.364 0c0 .949.608 1.757 1.455 2.057v1.183C1.868 5.878 0 8.062 0 10.667 0 13.607 2.393 16 5.333 16c1.931 0 3.656-1.044 4.592-2.623.132.125.31.199.5.199h1.939a.727.727 0 000-1.455zM5.333 14.545a3.879 3.879 0 01-3.878-3.878c0-1.802 1.228-3.326 2.909-3.757v3.03c0 .4.325.726.727.726h3.84l.223.671a3.882 3.882 0 01-3.82 3.208z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E";
    fab.appendChild(fabImg);
    document.body.appendChild(fab);
    elements.fab = fab;

    // Panel
    var panel = document.createElement('div');
    panel.className = 'a11y-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-modal', 'true');
    panel.setAttribute('aria-label', t('panelLabel'));
    panel.setAttribute('aria-hidden', 'true');
    document.body.appendChild(panel);
    elements.panel = panel;

    buildPanelContent();
  }

  function buildPanelContent() {
    var panel = elements.panel;
    var isRtl = state.lang === 'he';
    panel.dir = isRtl ? 'rtl' : 'ltr';

    panel.innerHTML = '';

    // Header
    var header = document.createElement('div');
    header.className = 'a11y-panel__header';

    var title = document.createElement('h2');
    title.className = 'a11y-panel__title';
    title.textContent = t('title');

    var actions = document.createElement('div');
    actions.className = 'a11y-panel__header-actions';

    var langBtn = document.createElement('button');
    langBtn.className = 'a11y-panel__lang-btn';
    langBtn.setAttribute('aria-label', state.lang === 'he' ? 'Switch to English' : '\u05e2\u05d1\u05e8 \u05dc\u05e2\u05d1\u05e8\u05d9\u05ea');
    langBtn.textContent = t('langSwitch');
    langBtn.addEventListener('click', toggleLang);

    var closeBtn = document.createElement('button');
    closeBtn.className = 'a11y-panel__close-btn';
    closeBtn.setAttribute('aria-label', t('close'));
    closeBtn.textContent = '\u00d7';
    closeBtn.addEventListener('click', closePanel);

    actions.appendChild(langBtn);
    actions.appendChild(closeBtn);
    header.appendChild(title);
    header.appendChild(actions);
    panel.appendChild(header);

    // Body
    var body = document.createElement('div');
    body.className = 'a11y-panel__body';

    // Font size increase
    var fontUpBtn = createFeatureButton('fontUp', 'A+', 'a11y-feature-btn--font-up');
    fontUpBtn.removeAttribute('aria-pressed');
    fontUpBtn.addEventListener('click', function () { changeFontSize(1); });
    body.appendChild(fontUpBtn);

    // Font size reset
    var fontResetBtn = createFeatureButton('fontReset', 'A', 'a11y-feature-btn--font-reset');
    fontResetBtn.removeAttribute('aria-pressed');
    fontResetBtn.addEventListener('click', function () { changeFontSize(0); });
    body.appendChild(fontResetBtn);

    // Toggle features
    TOGGLE_FEATURES.forEach(function (feature) {
      var isActive = !!state.features[feature.id];
      var btn = createFeatureButton(feature.id, feature.icon, '');
      btn.setAttribute('aria-pressed', String(isActive));
      btn.addEventListener('click', function () { toggleFeature(feature, btn); });
      body.appendChild(btn);
      elements['btn_' + feature.id] = btn;
    });

    // Reset all — full width
    var resetBtn = createFeatureButton('resetAll', '\u21ba', 'a11y-feature-btn--reset');
    resetBtn.removeAttribute('aria-pressed');
    resetBtn.addEventListener('click', resetAll);
    body.appendChild(resetBtn);

    panel.appendChild(body);

    // Update panel label
    panel.setAttribute('aria-label', t('panelLabel'));
    elements.fab.setAttribute('aria-label', t('fabLabel'));
  }

  function createFeatureButton(labelKey, iconText, extraClass) {
    var btn = document.createElement('button');
    btn.className = 'a11y-feature-btn' + (extraClass ? ' ' + extraClass : '');
    btn.setAttribute('aria-pressed', 'false');
    btn.setAttribute('aria-label', t(labelKey));
    btn.type = 'button';

    var icon = document.createElement('span');
    icon.className = 'a11y-feature-btn__icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = iconText;

    var label = document.createElement('span');
    label.className = 'a11y-feature-btn__label';
    label.textContent = t(labelKey);

    btn.appendChild(icon);
    btn.appendChild(label);
    return btn;
  }

  /* ── Panel Open/Close ── */
  function openPanel() {
    state.open = true;
    elements.panel.setAttribute('aria-hidden', 'false');
    elements.fab.setAttribute('aria-expanded', 'true');
    // Focus the first focusable element in the panel
    var first = elements.panel.querySelector('button');
    if (first) first.focus();
  }

  function closePanel() {
    state.open = false;
    elements.panel.setAttribute('aria-hidden', 'true');
    elements.fab.setAttribute('aria-expanded', 'false');
    elements.fab.focus();
  }

  function togglePanel() {
    if (state.open) { closePanel(); } else { openPanel(); }
  }

  /* ── Language Toggle ── */
  function toggleLang() {
    state.lang = state.lang === 'en' ? 'he' : 'en';
    try { localStorage.setItem(LANG_KEY, state.lang); } catch (e) { /* quota */ }
    buildPanelContent();
    // Restore focus to panel
    var first = elements.panel.querySelector('button');
    if (first) first.focus();
  }

  /* ── Feature Logic ── */
  function toggleFeature(feature, btn) {
    var isActive = state.features[feature.id];
    var newState = !isActive;
    state.features[feature.id] = newState;

    btn.setAttribute('aria-pressed', String(newState));

    if (feature.cssClass) {
      if (newState) {
        document.documentElement.classList.add(feature.cssClass);
      } else {
        document.documentElement.classList.remove(feature.cssClass);
      }
    }

    // Special: reading guide
    if (feature.id === 'readingGuide') {
      if (newState) {
        elements.readingGuide.classList.add('is-active');
        document.addEventListener('mousemove', moveReadingGuide);
      } else {
        elements.readingGuide.classList.remove('is-active');
        document.removeEventListener('mousemove', moveReadingGuide);
      }
    }

    announce(t(feature.id) + ' ' + (newState ? t('activated') : t('deactivated')));
    saveSettings();
  }

  function changeFontSize(direction) {
    // Remove current font class
    document.documentElement.classList.remove('a11y-font-1', 'a11y-font-2', 'a11y-font-3');

    if (direction === 0) {
      state.fontLevel = 0;
      announce(t('fontResetDone'));
    } else {
      state.fontLevel = Math.min(state.fontLevel + 1, 3);
      if (state.fontLevel > 0) {
        document.documentElement.classList.add('a11y-font-' + state.fontLevel);
      }
      announce(t('fontLevel') + ' ' + state.fontLevel);
    }

    saveSettings();
  }

  function resetAll() {
    // Remove all CSS classes
    document.documentElement.classList.remove(
      'a11y-font-1', 'a11y-font-2', 'a11y-font-3',
      'a11y-high-contrast', 'a11y-grayscale', 'a11y-link-highlight',
      'a11y-big-cursor', 'a11y-letter-spacing', 'a11y-line-height',
      'a11y-text-left', 'a11y-hide-images'
    );

    // Reading guide off
    elements.readingGuide.classList.remove('is-active');
    document.removeEventListener('mousemove', moveReadingGuide);

    // Reset state
    state.fontLevel = 0;
    state.features = {};
    saveSettings();

    // Rebuild panel to reset all button states
    buildPanelContent();

    announce(t('allReset'));

    // Focus first button in rebuilt panel
    var first = elements.panel.querySelector('.a11y-panel__body button');
    if (first) first.focus();
  }

  function moveReadingGuide(e) {
    elements.readingGuide.style.top = e.clientY + 'px';
  }

  /* ── Apply Saved Settings ── */
  function applySavedSettings() {
    // Font size
    if (state.fontLevel > 0 && state.fontLevel <= 3) {
      document.documentElement.classList.add('a11y-font-' + state.fontLevel);
    }

    // Toggle features
    TOGGLE_FEATURES.forEach(function (feature) {
      if (state.features[feature.id]) {
        if (feature.cssClass) {
          document.documentElement.classList.add(feature.cssClass);
        }
        if (feature.id === 'readingGuide') {
          elements.readingGuide.classList.add('is-active');
          document.addEventListener('mousemove', moveReadingGuide);
        }
      }
    });
  }

  /* ── Keyboard Navigation ── */
  function handleKeydown(e) {
    if (!state.open) return;

    if (e.key === 'Escape') {
      e.preventDefault();
      closePanel();
      return;
    }

    // Focus trap
    if (e.key === 'Tab') {
      var focusable = elements.panel.querySelectorAll('button');
      if (focusable.length === 0) return;

      var first = focusable[0];
      var last = focusable[focusable.length - 1];

      if (e.shiftKey) {
        if (document.activeElement === first) {
          e.preventDefault();
          last.focus();
        }
      } else {
        if (document.activeElement === last) {
          e.preventDefault();
          first.focus();
        }
      }
    }
  }

  /* ── Init ── */
  function init() {
    state.lang = detectLang();
    loadSettings();
    createWidget();
    applySavedSettings();

    // FAB click
    elements.fab.addEventListener('click', function (e) {
      e.preventDefault();
      togglePanel();
    });

    // Keyboard
    document.addEventListener('keydown', handleKeydown);

    // Close on outside click
    document.addEventListener('click', function (e) {
      if (!state.open) return;
      if (elements.panel.contains(e.target) || elements.fab.contains(e.target)) return;
      closePanel();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
